<template>
  <section @click="stopShow($event)" id="multipleSelect" class="multipleSelectFather">
    <section :id="randomId + 'father'"
      :style="{ 'max-width': width ? width + '!important' : '', 'min-width': width ? width + '!important' : '' }"
      class="multipleSelect">
      <section v-if="!needSearch">
        <section v-if="showSelectValue === ''"
          :style="{ 'background': newDisabled ? '#F5F5F5' : '', 'cursor': newDisabled ? ' no-drop' : 'pointer', 'border': newDisabled ? '1px solid #F5F5F5' : '1px solid #B62A40' }"
          :title="placeholder" @click="showDropFun" style="color: #ccc;font-size: 12px"
          class="multipleSelectShowPlace">{{ chooseData.length > 0 ? placeholder : $t('common.noData') }}</section>
        <section v-else
          :style="{ 'background': newDisabled ? '#F5F5F5' : '', 'cursor': newDisabled ? ' no-drop' : 'pointer', 'border': newDisabled ? '1px solid #F5F5F5' : '1px solid #B62A40' }"
          :title="showSelectValue" @click="showDropFun" class="multipleSelectShowPlace" style="font-size: 12px">
          <div>{{ showSelectValue }}</div>
          <div v-if="showSelectState"
            :class="{noSubmit: true, doneSubmit: showSelectedDatas&&showSelectedDatas.length>0&&showSelectedDatas[0][state]===$t('common.Done')}">
              {{(showSelectedDatas&&showSelectedDatas.length>0&&showSelectedDatas[0][state]) || $t('common.Pending') }}
          </div>
        </section>
      </section>
      <section v-else>
        <section v-if="showSelectValue === ''"
          :style="{ 'background': newDisabled ? '#F5F5F5' : '', 'cursor': newDisabled ? ' no-drop' : 'pointer', 'border': newDisabled ? '1px solid #F5F5F5' : '1px solid #B62A40' }"
          :title="placeholder" @click="needSearchShowDropFun"
          style="color: #ccc;font-size: 12px" class="multipleSelectShowPlace">
          <input @focus="backAllList" @input="searchValue" style="border: none;outline: none" :value="placeholder"
            type="text">
        </section>
        <section v-else
          :style="{ 'background': newDisabled ? '#F5F5F5' : '', 'cursor': newDisabled ? ' no-drop' : 'pointer', 'border': newDisabled ? '1px solid #F5F5F5' : '1px solid #B62A40' }"
          :title="showSelectValue" @click="needSearchShowDropFun" class="multipleSelectShowPlace"
          style="font-size: 12px">
          <input @focus="backAllList" @input="searchValue" style="border: none; outline: none;" :value="showSelectValue"
            type="text">
        </section>
      </section>
      <i @click="showDropFun" class="icon iconfont icon-sanjiaojiantou-xia multipleSelectArror"></i>
      <section :id="randomId" class="multipleSelectDrop">
        <section v-if="shownothing" disabled="disabled" class="multipleSelectSelectData">{{ $t('common.NoValueFound') }}
        </section>
        <section @click="confirmData(item)" :class="item.checked ? 'active' : ''" class="multipleSelectSelectData"
          v-for="(item, index) in selectData" :key="index" style="font-size: 12px">
          <div>{{ returnShowValue(item) }}</div>
          <div :class="{noSubmit: true, doneSubmit: item[state]===$t('common.Done')}" :state="item[state]" :tdone="$t('common.Done')" v-if="item.state">{{item[state] || $t('common.Pending') }}</div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
let timeOut
let array = []
export default {
  name: 'multipleSelect',
  model: {
    prop: 'selectValue',
    event: 'selectValue'
  },
  props: [
    'needSearch',
    'multiple',
    'selectValue',
    'chooseData',
    'needReturn',
    'showValue',
    'state',
    'matchValue',
    'placeholder',
    'width',
    'disabled',
    'item',
    'checkIsSave'
  ],
  data () {
    return {
      shownothing: false,
      newDisabled: this.disabled,
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000,
      newSelectValue: this.selectValue,
      showSelectValue: '',
      showSelectedDatas: [],
      showSelectState: false,
      selectData: this.chooseData
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    array = []
    this.handleData()
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    document.getElementById('index').addEventListener('click', closetab)
  },
  destroyed () {
    document.getElementById('index').removeEventListener('click', closetab)
  },
  methods: {
    searchValue (e) {
      clearTimeout(timeOut)
      timeOut = setTimeout(p => {
        let searchValue = e.target.value
        let selDom = document.getElementById(this.randomId)
        let selList = selDom.querySelectorAll('.multipleSelectSelectData')
        let num = 0
        for (let i = 0; i < selList.length; i++) {
          if (searchValue === '') {
            selList[i].style.display = 'block'
          } else {
            selList[i].style.display = 'none'
            if (selList[i].innerHTML.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0) {
              selList[i].style.display = 'block'
            }
          }
          if (selList[i].style.display !== 'none') {
            num++
          }
        }
        if (num === 0) {
          this.shownothing = true
        } else {
          this.shownothing = false
        }
      }, 500)
    },
    backAllList () {
      let selDom = document.getElementById(this.randomId)
      let selList = selDom.querySelectorAll('.multipleSelectSelectData')
      for (let i = 0; i < selList.length; i++) {
        selList[i].style.display = 'block'
      }
      this.shownothing = false
    },
    handleData () {
      this.showSelectValue = ''
      this.showSelectedDatas = []
      let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.toString().split(',')
      if (this.selectData) {
        for (let i = 0; i < this.selectData.length; i++) {
          this.$set(this.selectData[i], 'checked', false)
          for (let j = 0; j < splitValue.length; j++) {
            let _item = this.selectData[i]
            if (_item[this.needReturn].toString() === splitValue[j]) {
              _item.checked = true
              if (_item.state) {
                this.showSelectState = _item.state
              } else {
                this.showSelectState = false
              }
              this.showSelectValue += _item[this.matchValue] + ','
              this.showSelectedDatas.push(_item)
            }
          }
        }
      }
      this.showSelectValue = this.showSelectValue.substring(0, this.showSelectValue.length - 1)
      let html = this.showValue
      getItem(html)
    },
    confirmData (item) {
      let isGo = true
      if (this.checkIsSave) {
        isGo = confirm(this.$t('common.NoSaveRefresh'))
      }
      if (isGo) {
        if (this.multiple) {
          let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.split(',')
          let splitshowSelectValue = this.showSelectValue === '' ? [] : this.showSelectValue.split(',')
          if (item[this.needReturn].toString() === '' && splitValue.length > 0) {
            splitValue = ['']
          }
          if (splitValue.indexOf(item[this.needReturn].toString()) >= 0) {
            splitValue.splice(splitValue.indexOf(item[this.needReturn].toString()), 1)
            splitshowSelectValue.splice(splitshowSelectValue.indexOf(item[this.needReturn].toString()), 1)
            let selectHmtl = ''
            let selectHmtl2 = ''
            for (let i = 0; i < splitValue.length; i++) {
              selectHmtl += splitValue[i] + ','
              selectHmtl2 += splitshowSelectValue[i] + ','
            }
            selectHmtl = selectHmtl.substring(0, selectHmtl.length - 1)
            selectHmtl2 = selectHmtl2.substring(0, selectHmtl2.length - 1)
            this.newSelectValue = selectHmtl
            this.showSelectValue = selectHmtl2
            this.$emit('selectValue', this.newSelectValue)
            if (this.item) {
              item.object = this.item
            }
            this.$emit('on-change', item)
          } else {
            if (this.newSelectValue === '') {
              this.newSelectValue += item[this.needReturn]
            } else {
              this.newSelectValue += ',' + item[this.needReturn]
            }
            this.$emit('selectValue', this.newSelectValue)
            if (this.item) {
              item.object = this.item
            }
            this.$emit('on-change', item)
            if (this.showSelectValue === '') {
              this.showSelectValue += item[this.matchValue]
            } else {
              this.showSelectValue += ',' + item[this.matchValue]
            }
          }
          this.handleData()
          this.$emit('submit', this.showSelectValue)
        } else {
          this.newSelectValue = item[this.needReturn]
          this.showSelectValue = item[this.matchValue]
          this.showSelectState = item[this.state]
          this.$emit('selectValue', this.newSelectValue)
          if (this.item) {
            item.object = this.item
          }
          this.$emit('on-change', item)
          let dom = document.getElementById(this.randomId)
          dom.style.opacity = '0'
          setTimeout(p => {
            dom.style.display = 'none'
          }, 200)
        }
      } else {
        closetab()
        this.$emit('autoSave')
      }
    },
    needSearchShowDropFun () {
      if (!this.newDisabled) {
        this.backAllList()
        let dom = document.getElementById(this.randomId)
        let domList = document.querySelectorAll('.multipleSelectFather')
        for (let i = 0; i < domList.length; i++) {
          domList[i].style.zIndex = 1
        }
        dom.parentNode.parentNode.style.zIndex = 2
        if (dom.style.display === 'none' || dom.style.display === '') {
          dom.style.display = 'block'
          setTimeout(p => {
            dom.style.opacity = '1'
          }, 10)
        }
      }
    },
    showDropFun () {
      if (!this.newDisabled) {
        let fatherId = document.getElementById(this.randomId + 'father')
        let dom = document.getElementById(this.randomId)
        dom.style.width = fatherId.clientWidth + 'px'
        let domList = document.querySelectorAll('.multipleSelectFather')
        for (let i = 0; i < domList.length; i++) {
          domList[i].style.zIndex = 1
        }
        dom.parentNode.parentNode.style.zIndex = 2
        if (dom.style.display === 'none' || dom.style.display === '') {
          let canderList = document.querySelectorAll('.multipleSelectDrop')
          if (canderList.length > 0) {
            for (let i = 0; i < canderList.length; i++) {
              canderList[i].style.display = 'none'
              canderList[i].style.opacity = '0'
            }
          }
          dom.style.display = 'block'
          setTimeout(p => {
            dom.style.opacity = '1'
          }, 10)
        } else {
          dom.style.opacity = '0'
          setTimeout(p => {
            dom.style.display = 'none'
          }, 200)
        }
      }
    },
    returnShowValue (object) {
      let html = this.showValue
      for (let i = 0; i < array.length; i++) {
        html = html.replace('{{' + array[i] + '}}', object[array[i]])
      }
      return html
    },
    stopShow (e) {
      e.stopPropagation()
    }
  },
  watch: {
    selectValue (value) {
      this.newSelectValue = value
      this.showSelectValue = ''
      this.handleData()
    },
    chooseData (value) {
      this.selectData = value
      this.handleData()
    },
    disabled (value) {
      this.newDisabled = value
    }
  },
  computed: {
  }
}
function closetab () {
  let canderList = document.querySelectorAll('.multipleSelectDrop')
  if (canderList) {
    for (let i = 0; i < canderList.length; i++) {
      canderList[i].style.opacity = '0'
    }
    setTimeout(p => {
      for (let i = 0; i < canderList.length; i++) {
        canderList[i].style.display = 'none'
      }
    }, 200)
  }
}
function getItem (html) {
  if (html.indexOf('{{') >= 0) {
    let aPos = html.indexOf('{{')
    let bPos = html.indexOf('}}')
    let newName = html.substr(aPos + 2, bPos - aPos - 2)
    array.push(newName)
    html = html.replace('{{', '').replace('}}', '')
    getItem(html)
  }
}
</script>

<style scoped>
.multipleSelectFather {
  position: relative;
}

.multipleSelect {
  position: relative;
  max-width: 180px;
  min-width: 180px;
  width: 100%;
  text-align: left;
  z-index: 5;
}

.multipleSelect .multipleSelectShowPlace {
  background-color: #fff;
  padding: 6px 25px 6px 10px;
  border-radius: 50px;
  border: 1px solid #c73343;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}

.multipleSelect .multipleSelectDrop {
  position: absolute;
  top: 32px;
  background: #fff;
  width: 100%;
  display: none;
  opacity: 0;
  transition: opacity 0.2s;
  max-height: 200px;
  overflow: auto;
  box-shadow: 0px 0px 5px 0px #ccc;
  border-radius: 4px;
  margin-bottom: 60px;
}

.multipleSelect .multipleSelectDrop .multipleSelectSelectData {
  padding: 6px 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: space-between;
}

/*.multipleSelect .multipleSelectDrop .multipleSelectSelectData.active::after{*/
/*  content: '√';*/
/*  font-family: "微软雅黑", "Arial";*/
/*  position: absolute;*/
/*  right: 5px;*/
/*}*/
.multipleSelect .multipleSelectDrop .multipleSelectSelectData.active {
  color: #c73343;
}

.multipleSelect .multipleSelectDrop .multipleSelectSelectData:hover {
  /*color: #fff;*/
  cursor: pointer;
  background: #f1f1f1;
}

.multipleSelectArror {
  position: absolute;
  right: 8px;
  top: 9px;
  color: #c73343;
  font-size: 10px;
  font-weight: bold;
}

@media screen and (max-width: 1370px) {
  .multipleSelect {
    max-width: 200px !important;
    min-width: 200px !important;
  }
}

.noSubmit {
  color: #b62a40;
  font-weight: bold;
}

.doneSubmit {
  color: #09702b !important;
}

</style>



// WEBPACK FOOTER //
// src/components/myComponents/multipleSelect.vue